/**
 * @generated SignedSource<<b37681f19fcb2e1ec6c0595174ec0c93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CollectionFolderDashboardBlockFragment$data = {
  readonly content: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CollectionFolderDashboardBlockContentFragment" | "DashboardBlockItemTemplateFragment">;
  readonly " $fragmentType": "CollectionFolderDashboardBlockFragment";
};
export type CollectionFolderDashboardBlockFragment$key = {
  readonly " $data"?: CollectionFolderDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CollectionFolderDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CollectionFolderDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockItemTemplateFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CollectionFolderDashboardBlockContentFragment"
    }
  ],
  "type": "CollectionFolderDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "0560d59d9c0d4bab828ba00b4f92de87";

export default node;
